var map = {
	"./add-btn.svg": "1f85",
	"./asterisk-14.png": "504c",
	"./bg-dots.svg": "6b32",
	"./bg-home-welcome.png": "1a1b",
	"./bytorg_Logo.svg": "456c",
	"./check-off.svg": "60e3",
	"./check-on.svg": "18b7",
	"./close-btn.svg": "cd0f",
	"./expand_less-black-24dp.svg": "89a0",
	"./expand_more-black-24dp.svg": "9969",
	"./ico-arrow-down.svg": "f4d7",
	"./ico-bell-ring-outline-grey.svg": "5917",
	"./ico-briefcase-search-outline-grey.svg": "9088",
	"./ico-checkbox-checked-grey.svg": "c169",
	"./ico-checkbox-checked.svg": "2e8d",
	"./ico-checkbox-partly.svg": "c48b",
	"./ico-checkbox-unchecked.svg": "4f2b",
	"./ico-color.svg": "f303",
	"./ico-file-document-outline-grey.svg": "b64a",
	"./ico-filter-plus-grey.svg": "053e",
	"./ico-filter-plus-white.svg": "9ed2",
	"./ico-flag.svg": "f5a6",
	"./icon-at-symbol.svg": "4937",
	"./icon-copy.svg": "b43f",
	"./icon-trash.svg": "bfe5",
	"./logo-white.png": "39cc",
	"./logo-white.svg": "e1d6",
	"./logo.png": "4ffd",
	"./logo.svg": "1ae4",
	"./menu-collapse.svg": "69c2",
	"./remove-btn.svg": "8d75",
	"./tab-copy.svg": "7e1f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";